import React from 'react';

import EntityViewer from '../entity-viewer/EntityViewer';

import { TestID } from '../../testID';

import type { Pipe } from '../../types/pipes.types';

import './PipeInput.css';

export const FetchedRemoteEntities: React.FC<{ pipe: Pipe }> = ({ pipe }) => (
  <div data-testid={TestID.PipeInputFetchedRemoteEntities} className="pipe-input">
    <div className="pipe-input__description">
      <h1 className="heading-page">Input entities</h1>
      <p className="output-">Input entities from the source</p>
    </div>
    <div className="pipe-input__content">
      <EntityViewer pipe={pipe} stage="source" />
    </div>
  </div>
);
